import type { TranslationSchema } from '../pt-BR';
import type { DeepPartialStrings } from '../types';

export const receipts = {
    header: {
        title: 'Import receipt',
    },
    actions: {
        gallery: {
            title: 'Gallery',
            subtitle: 'Screenshot or photo',
        },
        camera: {
            title: 'Camera',
            subtitle: 'Take a photo',
        },
        pdf: {
            title: 'PDF',
            subtitle: 'Bank file',
        },
    },
    scanning: {
        title: 'Processing receipt...',
        subtitlePdf: 'Reading text from PDF',
        subtitleImage: 'Extracting text with OCR',
    },
    preview: {
        pdfFallback: 'Imported PDF',
    },
    result: {
        bankLabel: 'Bank',
        amountLabel: 'Amount',
        amountValue: 'R$ {{value}}',
        typeLabel: 'Type',
        descriptionLabel: 'Description',
        scanAnother: 'Scan another receipt',
        goHome: 'Back to home',
        pendingHint: 'The pending entry is saved on the home screen — confirm it whenever you want.',
    },
    fallbackDescription: {
        generic: 'Imported receipt',
        withBank: '{{bank}} receipt',
    },
    error: {
        title: 'Couldn\'t process',
        tryAgain: 'Try again',
        processFallback: 'Error processing receipt',
    },
    notIdentified: {
        title: 'Receipt not recognized',
        messagePdf: 'Couldn\'t extract the amount from this PDF.',
        messageImage: 'Couldn\'t extract the amount from this receipt. Try a sharper image.',
    },
    permission: {
        title: 'Permission required',
        message: 'Allow camera access to take a photo of the receipt.',
    },
    toast: {
        errorTitle: 'Processing error',
        errorFallback: 'Try again.',
    },
    okButton: 'OK',
} satisfies DeepPartialStrings<TranslationSchema['receipts']>;
